import { ChartData, ChartOptions, Plugin } from 'chart.js'
import { getBaseChartOptions, CHART_COLORS, getMaxValueWithPadding, createDataLabelsPlugin } from '../common'
import { PeriodType } from '../../PeriodTypeSelector'

const COLORS = {
  submissionSLA: CHART_COLORS.primary,
  targetSLA: CHART_COLORS.secondary
} as const

const dataLabelsPlugin: Plugin = createDataLabelsPlugin(
  0,
  COLORS.submissionSLA.border,
  {
    textAlign: 'end',
    textBaseline: 'bottom',
    format: (value) => `${value}%`
  }
)

export const chartPlugins = [dataLabelsPlugin]

export const getMaxValue = (actualValues: (number | null)[]): number =>
  getMaxValueWithPadding(actualValues, 100)

export const getChartOptions = (
  labels: string[] = [],
  actualValues: (number | null)[] = [],
  periodType: PeriodType = PeriodType.MONTH
): ChartOptions<'line'> => {
  const maxYValue = getMaxValue(actualValues)
  
  return {
    ...getBaseChartOptions(),
    layout: {
      padding: {
        left: 10,
        right: 20,
        top: 30,
        bottom: 10
      }
    },
    plugins: {
      ...getBaseChartOptions().plugins,
      legend: {
        position: 'top' as const,
        onClick: () => null
      },
      tooltip: {
        callbacks: {
          label(context) {
            const value = context.parsed.y
            if (value === undefined || value === null) {
              return 'No data'
            }
            return `${context.dataset.label}: ${value.toFixed(2)}%`
          }
        },
        intersect: false,
        enabled: true,
      }
    },
    scales: {
      y: {
        min: 0,
        max: maxYValue,
        ticks: {
          callback(value) {
            return typeof value === 'number' && value <= 100 ? `${value}` : ''
          },
          stepSize: 10,
        },
        grid: {
          drawBorder: true,
          color: 'rgba(0,0,0,0.1)'
        },
        title: {
          display: true,
          text: 'On Time Submission (%)',
          font: {
            weight: 'bold' as const
          }
        }
      },
      x: {
        offset: true,
        title: {
          display: true,
          text: periodType,
          font: {
            weight: 'bold' as const
          }
        },
        ticks: {
          autoSkip: false,
          padding: 10
        }
      }
    }
  }
}

export const getChartDataConfig = (
  labels: string[],
  actualValues: (number | null)[],
  targetValues: (number | null)[]
): ChartData<'line'> => ({
  labels,
  datasets: [
    {
      label: 'Submission SLA',
      data: actualValues,
      borderColor: COLORS.submissionSLA.border,
      backgroundColor: COLORS.submissionSLA.background,
      tension: 0.3,
      pointRadius: 4,
      pointHoverRadius: 6,
    },
    {
      label: 'SLA Target (95%)',
      data: targetValues,
      borderColor: COLORS.targetSLA.border,
      backgroundColor: COLORS.targetSLA.background,
      borderDash: [5, 5],
      tension: 0,
      pointRadius: 0,
    }
  ]
})